import Head from 'next/head'
import { getStrapiMedia } from '../../lib/blog/media'

const defaultShareImage = `https://ivyflip.com/img/og-image.png`

const Seo = ({ seo }) => {
  if (!seo) {
    return
  }

  const fullSeo = {
    ...seo,
    metaTitle: seo.metaTitle ? `${seo.metaTitle} | Ivy Flip` : null,
    shareImage: getStrapiMedia(seo.shareImage) ?? defaultShareImage
  }

  return (
    <Head>
      {fullSeo.metaTitle && (
        <>
          <title>{fullSeo.metaTitle}</title>
          <meta property="og:title" content={fullSeo.metaTitle} />
          <meta name="twitter:title" content={fullSeo.metaTitle} />
        </>
      )}
      {fullSeo.metaDescription && (
        <>
          <meta name="description" content={fullSeo.metaDescription} />
          <meta property="og:description" content={fullSeo.metaDescription} />
          <meta name="twitter:description" content={fullSeo.metaDescription} />
        </>
      )}
      {fullSeo.shareImage && (
        <>
          <meta property="og:image" content={fullSeo.shareImage} />
          <meta name="twitter:image" content={fullSeo.shareImage} />
          <meta name="image" content={fullSeo.shareImage} />
        </>
      )}
      {fullSeo.schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(fullSeo.schema) }}
        />
      )}
      {fullSeo.article && (
        <meta property="og:type" content="article"/>
      )}
      <meta name="twitter:card" content="summary_large_image" />
    </Head>
  )
}

export default Seo
